//valves
import { App as ValveVar } from './ValveVar/appDeclaration';
import { App as ValveTwoPoint } from './ValveTwoPoint/appDeclaration';
import { App as ValveThreePoint } from './ValveThreePoint/appDeclaration';
import { App as BelimoEnergyValve } from './BelimoEnergyValve/appDeclaration';
import { App as VolumetricFlowController } from './VolumetricFlowController/appDeclaration';
///Drives
import {
    App as DriveVarSpeed,
    AppFan as DriveVarSpeedFan,
    AppPump as DriveVarSpeedPump,
    AppPump1 as DriveVarSpeedPump1,
    AppPump2 as DriveVarSpeedPump2
} from './DriveVarSpeed/appDeclaration';
import {
    App as DriveOneSpeed,
    AppFan as DriveOneSpeedFan,
    AppPump as DriveOneSpeedPump,
    AppOutput as DriveOneSpeedOutput,
    AppPump1 as DriveOneSpeedPump1,
    AppPump2 as DriveOneSpeedPump2
} from './DriveOneSpeed/appDeclaration';
import {
    App as DriveTwoSpeed,
    AppFan as DriveTwoSpeedFan
} from './DriveTwoSpeed/appDeclaration';
import {
    App as DriveThreeSpeed,
    AppFan as DriveThreeSpeedFan
} from './DriveThreeSpeed/appDeclaration';

//HeatingFire
import {
    AppEHeat as EHeating,
} from './ElectricHeatingElement/appDeclaration';

///Sensors
import {
    App as SensorAnalog,
    AppTemp as SensorAnalogTemp,
    AppTemp1 as SensorAnalogTemp1,
    AppTemp2 as SensorAnalogTemp2,
    AppTemp3 as SensorAnalogTemp3,
    AppTemp4 as SensorAnalogTemp4,
    AppTemp5 as SensorAnalogTemp5,
    AppTemp6 as SensorAnalogTemp6,
    AppHum as SensorAnalogHum,
    AppPress as SensorAnalogPress,
    AppTempFlow as SensorAnalogTempFlow,
    AppTempOutlet as SensorAnalogTempOutlet
} from './SensorAnalog/appDeclaration';
import {
    App as SensorDigitalAlarm,
    AppMotion as SensorDigitalAlarmMotion,
    AppFilter as SensorDigitalAlarmFilter,
    AppFreeze as SensorDigitalAlarmFreeze,
    AppRepairSwitch as SensorDigitalAlarmRepairSwitch
} from './SensorDigitalAlarm/appDeclaration';
import {
    App as SensorDigitalInformation,
} from './SensorDigitalInformation/appDeclaration';
import {
    App as SensorDigitalMaintenance,
} from './SensorDigitalMaintenance/appDeclaration';
import {
    App as WindowContact,
} from './WindowContact/appDeclaration';
import { App as SensorDigital } from './SensorDigital/appDeclaration';
import { App as SensorDigitalFault } from './SensorDigitalFault/appDeclaration';
//Commons
import { App as Acknowledge } from './Acknowledge/appDeclaration';
import { App as MultiState } from './MultiState/appDeclaration';
import { App as MultiStateSwitch } from './MultiStateSwitch/appDeclaration';
//Switches
import { App as Multisensor } from './Multisensor/appDeclaration';
//Counters
import { App as Counter } from './Counter/appDeclaration';
import { App as OperationHoursCounter } from './OperationHoursCounter/appDeclaration';
import { App as VirtualCounter } from './VirtualCounter/appDeclaration';
//FireDampers
import { App as FireDamperOpenClose } from './FireDamperOpenClose/appDeclaration';
// devices
import { App as EdgeDevice } from './EdgeDevice/appDeclaration'
import { App as BacnetDevice } from './BacnetDevice/appDeclaration'

//lights
import { App as Light } from './Light/appDeclaration'
import { App as LightVar } from './LightVar/appDeclaration'

export const Apps = {
    [Acknowledge.schema]: Acknowledge,
    [BacnetDevice.schema]: BacnetDevice,
    [EdgeDevice.schema]: EdgeDevice,
    [Counter.schema]: Counter,
    [VirtualCounter.schema]: VirtualCounter,
    [DriveOneSpeed.schema]: DriveOneSpeed,
    [DriveOneSpeedFan.schema]: DriveOneSpeedFan,
    [DriveOneSpeedOutput.schema]: DriveOneSpeedOutput,
    [DriveOneSpeedPump.schema]: DriveOneSpeedPump,
    [DriveOneSpeedPump1.schema]: DriveOneSpeedPump1,
    [DriveOneSpeedPump2.schema]: DriveOneSpeedPump2,
    [DriveVarSpeed.schema]: DriveVarSpeed,
    [DriveVarSpeedFan.schema]: DriveVarSpeedFan,
    [DriveVarSpeedPump.schema]: DriveVarSpeedPump,
    [DriveVarSpeedPump1.schema]: DriveVarSpeedPump1,
    [DriveVarSpeedPump2.schema]: DriveVarSpeedPump2,
    [DriveTwoSpeed.schema]: DriveTwoSpeed,
    [DriveTwoSpeedFan.schema]: DriveTwoSpeedFan,
    [DriveThreeSpeed.schema]: DriveThreeSpeed,
    [DriveThreeSpeedFan.schema]: DriveThreeSpeedFan,
    [EHeating.schema]: EHeating,
    [FireDamperOpenClose.schema]: FireDamperOpenClose,
    [SensorDigital.schema]: SensorDigital,
    [OperationHoursCounter.schema]: OperationHoursCounter,
    [MultiState.schema]: MultiState,
    [MultiStateSwitch.schema]: MultiStateSwitch,
    [Multisensor.schema]: Multisensor,
    [SensorAnalog.schema]: SensorAnalog,
    [SensorAnalogTempFlow.schema]: SensorAnalogTempFlow,
    [SensorAnalogHum.schema]: SensorAnalogHum,
    [SensorAnalogTempOutlet.schema]: SensorAnalogTempOutlet,
    [SensorAnalogPress.schema]: SensorAnalogPress,
    [SensorAnalogTemp.schema]: SensorAnalogTemp,
    [SensorAnalogTemp1.schema]: SensorAnalogTemp1,
    [SensorAnalogTemp2.schema]: SensorAnalogTemp2,
    [SensorAnalogTemp3.schema]: SensorAnalogTemp3,
    [SensorAnalogTemp4.schema]: SensorAnalogTemp4,
    [SensorAnalogTemp5.schema]: SensorAnalogTemp5,
    [SensorAnalogTemp6.schema]: SensorAnalogTemp6,
    [SensorDigitalAlarm.schema]: SensorDigitalAlarm,
    [SensorDigitalAlarmFilter.schema]: SensorDigitalAlarmFilter,
    [SensorDigitalAlarmFreeze.schema]: SensorDigitalAlarmFreeze,
    [SensorDigitalAlarmMotion.schema]: SensorDigitalAlarmMotion,
    [SensorDigitalAlarmRepairSwitch.schema]: SensorDigitalAlarmRepairSwitch,
    [SensorDigitalInformation.schema]: SensorDigitalInformation,
    [SensorDigitalMaintenance.schema]: SensorDigitalMaintenance,
    [SensorDigitalFault.schema]: SensorDigitalFault,
    [WindowContact.schema]: WindowContact,

    ///Valves
    [ValveVar.schema]: ValveVar,
    [ValveTwoPoint.schema]: ValveTwoPoint,
    [ValveThreePoint.schema]: ValveThreePoint,
    [BelimoEnergyValve.schema]: BelimoEnergyValve,
    [VolumetricFlowController.schema]: VolumetricFlowController,
    //Lights
    [Light.schema]: Light,
    [LightVar.schema]: LightVar,
}